module.exports = {"Contacts":{"1":"Contacts","42":"კონტაქტი"},"Know more about us":{"1":"Know more about us, contact us:","42":"გაიგეთ ჩვენს შესახებ მეტი, დაგვიკავშირდით:"},"Address":{"1":"Address","42":"მისამართი"},"7 Innovations Str. Tbilisi, Georgia":{"1":"7 Innovations Str. Tbilisi, Georgia","42":"ინოვაციების ქუჩა 7, თბილისი, საქართველო"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/eng.json
// module id = 606K
// module chunks = 1